function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "142.945,38.949 145.5,28.572 146.615,28.572 147.895,22.186 145.182,22.186 143.586,13.889  143.264,8.301 137.676,5.91 133.842,1.119 129.381,0 124.748,3.193 118.369,2.716 117.25,4.791 111.186,7.509 113.094,25.855  109.27,42.139 44.782,129.61 49.73,197.29 54.996,193.616 63.935,200 77.187,168.236 87.718,166.157 97.934,145.891  100.166,154.188 97.612,165.366 103.998,166.961 103.998,169.352 107.029,178.452 109.75,180.046 112.775,167.758 119.484,124.502  122.836,120.035 120.6,119.234 114.211,125.303 113.094,118.913 119.16,115.728 122.836,112.055 123.629,105.349 114.211,108.862  110.385,107.743 115.334,95.77 120.279,95.77 121.398,87.468 119.16,78.375  "
}));

var Svg23 = function Svg23(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "QROO",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg23, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/23.5727a685.svg";
export { ForwardRef as ReactComponent };